import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function getCommentList(token, api_token, type, uuid, page) {

    let endpoint = `${API_ENDPOINT}/comment?`;
    let headers = {
        ...AUTH_HEADERS
    };
    if (api_token !== null) {
        endpoint += `api_token=${api_token}&`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }

    endpoint += `type=${type}&uuid=${uuid}&page=${page}`

    return {
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers,
            types: [types.GET_COMMENTS_REQUEST, types.GET_COMMENTS_RECEIVE, {
                type: types.GET_COMMENTS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCommentList = () => ({
    type: types.RESET_GET_COMMENTS,
    payload: null
});

export function createComment(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/comment?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.CREATE_COMMENT_REQUEST, types.CREATE_COMMENT_RECEIVE, {
                type: types.CREATE_COMMENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCreateComment = () => ({
    type: types.RESET_CREATE_COMMENT,
    payload: null
});

export function updateComment(token, api_token, comment_id,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/comment/${comment_id}?api_token=${api_token}`,
            method: 'PUT',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.UPDATE_COMMENT_REQUEST, types.UPDATE_COMMENT_RECEIVE, {
                type: types.UPDATE_COMMENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetUpdateComment = () => ({
    type: types.RESET_UPDATE_COMMENT,
    payload: null
});

export function deleteComment(token, api_token, comment_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/comment/${comment_id}?api_token=${api_token}`,
            method: 'DELETE',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.DELETE_COMMENT_REQUEST, types.DELETE_COMMENT_RECEIVE, {
                type: types.DELETE_COMMENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetDeleteComment = () => ({
    type: types.RESET_DELETE_COMMENT,
    payload: null
});